import {
    AnimationBaseController,
    AnimationClipContainer,
    Collisions,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { GameModel } from '../../Models/GameModel';
import { RoomModel } from '../../Models/RoomModel';
import { EnvironmentModel } from '../../Models/EnvironmentModel';
import { MiniGameModel, MiniGameTypeEnum } from '../../Models/MiniGameModel';
import { BorderModel, BorderTypeEnum } from '../../Models/BorderModel';

export class RoomController extends AnimationBaseController {
    $model: RoomModel;

    public constructor(@Inject private _options,
                       @Inject private _gameModel: GameModel,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _random: GameRandom,
                       @Inject private _collisions: Collisions) {
        super('RoomController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {},
            modelWatch: {
                pos: (pos: [number, number]) => {
                    this.x = pos[0];
                    this.y = pos[1];
                },
                visible: (visible: boolean) => {
                    this.visible = visible;
                },
                x: (x: number) => {
                },
                y: (y: number) => {
                    this.setTextByQuery('index_text', `${this.$model.index}[${this.$model.x},${this.$model.y}]`);
                },
            },
        };
    }

    protected onInitialize(): void {
        this.x = this.$model.pos[0];
        this.y = this.$model.pos[1];

        this.visible = this.$model.visible;
        this.setTextByQuery('index_text', '');

        this.createCollisions();
        this.getCurrentAnimationClipChildren(displayObject => {
            if (displayObject instanceof AnimationClipContainer) {
                let animationClip: AnimationClipContainer = displayObject;

                if (animationClip.name.includes('environment')) {
                    this.addEnvironment(animationClip);

                } else if (animationClip.name.includes('outline_line_c_top')) {
                    this.addBorder(animationClip, BorderTypeEnum.line_c, this.$model.index, true);

                } else if (animationClip.name.includes('outline_line_c')) {
                    this.addBorder(animationClip, BorderTypeEnum.line_c, this.$model.index);

                } else if (animationClip.name.includes('outline_line_r')) {
                    this.addBorder(animationClip, BorderTypeEnum.line_r, this.$model.index);

                } else if (animationClip.name.includes('outline_line_l')) {
                    this.addBorder(animationClip, BorderTypeEnum.line_l, this.$model.index);

                } else if (animationClip.name.includes('outline_angle_top')) {
                    this.addBorder(animationClip, BorderTypeEnum.angle, this.$model.index, true);

                } else if (animationClip.name.includes('outline_angle2_top')) {
                    this.addBorder(animationClip, BorderTypeEnum.angle2, this.$model.index, true);

                } else if (animationClip.name.includes('outline_angle')) {
                    this.addBorder(animationClip, BorderTypeEnum.angle, this.$model.index);

                } else if (animationClip.name.includes('anchor_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.anchor);

                } else if (animationClip.name.includes('ropes_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.ropes);

                } else if (animationClip.name.includes('laser_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.laser);

                } else if (animationClip.name.includes('boat_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.boat);

                } else if (animationClip.name.includes('wheel_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.wheel);

                } else if (animationClip.name.includes('task_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.task);

                } else if (animationClip.name.includes('engine_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.engine);

                } else if (animationClip.name.includes('fuel_symbol')) {
                    this.addMiniGame(animationClip, MiniGameTypeEnum.fuel);
                }
            }
        });
    }

    private createCollisions(): void {
        this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
            shapeContainer.visible = false;

            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];
                if (path[0][0] == path[path.length - 1][0] &&
                    path[0][1] == path[path.length - 1][1]) {
                    this._collisions.createPolygon(this.x + x, this.y + y, path);

                } else {
                    for (let j = 0; j < path.length - 1; j++) {
                        this._collisions.createPolygon(this.x + x, this.y + y, [path[j], path[j + 1]]);
                    }
                }

            }
        }, 'collisions');
    }

    private addEnvironment(animationClip: AnimationClipContainer): EnvironmentModel {
        this.createEnvironmentCollisions(animationClip);

        let type = '';

        this.getCurrentSprites((sprite) => {
            type = sprite.name;
        }, animationClip.name);

        animationClip.visible = false;

        return this.$model.addEnvironment([animationClip.x, animationClip.y], animationClip.name, type);
    }

    private addMiniGame(animationClip: AnimationClipContainer, type: MiniGameTypeEnum): MiniGameModel {
        this.createMiniGameCollisions(animationClip);

        animationClip.visible = false;

        return this.$model.addMiniGame(
            [animationClip.x, animationClip.y],
            `${type}_symbol`,
            type,
        );
    }

    private createEnvironmentCollisions(animationClip: AnimationClipContainer): void {
        this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
            shapeContainer.visible = false;

            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];

                for (let j = 0; j < path.length - 1; j++) {
                    this._collisions.createPolygon(this.x + animationClip.x + x, this.y + animationClip.y + y, [path[j], path[j + 1]]);
                }

            }
        }, `${animationClip.name}`);
    }

    private createMiniGameCollisions(animationClip: AnimationClipContainer): void {
        /*
        this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
            shapeContainer.visible = false;

            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];

                for (let j = 0; j < path.length - 1; j++) {
                    this._collisions.createPolygon(this.x + animationClip.x + x, this.y + animationClip.y + y, [path[j], path[j + 1]]);
                }

            }
        }, `${animationClip.name}.environments`);
         */
    }

    private addBorder(animationClip: AnimationClipContainer, type: BorderTypeEnum, roomIndex: string, isOnTop: boolean = false): BorderModel {
        this.createMiniGameCollisions(animationClip);

        animationClip.visible = false;

        return this.$model.addBorder(
            [animationClip.x, animationClip.y],
            animationClip.rotation,
            animationClip.width,
            animationClip.height,
            type,
            roomIndex,
            isOnTop
        );
    }
}

